// variant params used by the build-time PDF generator (?pdf=1&audience=…).
// Absent for every visitor, so parsing is evaluated once at module load and
// must stay null-safe
const PDF_PARAMS = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : null

export const isPdfMode = PDF_PARAMS?.get("pdf") === "1"

export const pdfVariantParam = <T extends string>(name: string, values: readonly T[]): T | null => {
    const value = PDF_PARAMS?.get(name)
    return value && (values as readonly string[]).includes(value) ? (value as T) : null
}

// "66912341234" → { code: "66", rest: "912341234" }
export const pdfPhoneParam = () => {
    const digits = (PDF_PARAMS?.get("phone") ?? "").replace(/\D/g, "")
    return digits.length >= 2 ? { code: digits.slice(0, 2), rest: digits.slice(2) } : null
}
